import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import styles from './notifications.less';
export default function Notifications() {
    return React.createElement(ToastContainer, { className: styles.container, bodyClassName: styles.toastBody, toastClassName: styles.toast, position: 'bottom-right' });
}
